import { gql } from "@apollo/client";

export const FETCH_PROCESS_ORDERS_V4 = gql`
  query FetchProcessOrdersV4($startDate: String!) {
    me {
      processedOrdersV4(startDate: $startDate) {
        processedOrders {
          order_id
          occurred_at
        }
      }
      notProcessedOrdersV4 {
        notProcessedOrders {
          order_id
          occurred_at
        }
      }
      processingOrdersV4 {
        processingOrders {
          order_id
          occurred_at
        }
      }
    }
  }
`;
